import { render, staticRenderFns } from "./PublicationMunMehDeleteExpert1Modal.vue?vue&type=template&id=45004e42&"
import script from "./PublicationMunMehDeleteExpert1Modal.vue?vue&type=script&lang=js&"
export * from "./PublicationMunMehDeleteExpert1Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
